<div class="no-records text-align_center" *ngIf="show">
  <h1 class="colored">{{_locale.noRecords.noRecords}}</h1>
</div>

